export const COLOR_HISTORY = {
  START_COLOR: '#0d1117',
  END_COLOR: '#0d1117',
  STOP_COLOR: '#AA1313',
  FRAME_DEFAULT_COLOR: '#79C0FF',
  FRAME_VARIANT_V1_COLOR: '#FFC107',
  // ROUTE_COLOR: '#000000',
  ROUTE_COLOR: '#4f46e5',
  // ROUTE_MOVEMENT_COLOR: '#2563EB',
  ROUTE_MOVEMENT_COLOR: '#dc2626',
};
